import { Controller } from "@hotwired/stimulus"

// In an iframe, passes a shortcut on to the page around it, which never sees keys pressed once someone has
// clicked into the frame: keydown.ctrl+k@document->relay-key#relay
export default class extends Controller {
  relay(event) {
    if (window.parent === window) return

    event.preventDefault()
    const { key, ctrlKey, metaKey, shiftKey, altKey } = event
    window.parent.document.dispatchEvent(new KeyboardEvent("keydown", { key, ctrlKey, metaKey, shiftKey, altKey, bubbles: true }))
  }
}
